import { captureMessage } from '@sentry/react';

const timeoutError = Symbol();

const timeout = (fn: Promise<unknown>, time: number, exception: symbol) => {
  let timer: string | number | NodeJS.Timeout | undefined;
  const timerPromise = new Promise((_r, rej) => (timer = setTimeout(rej, time, exception)));
  return Promise.race([fn, timerPromise]).finally(() => clearTimeout(timer));
};

export const attemptToGetHeartBeat = async (paymentReference: string, locationId: string): Promise<string> => {
  window.webkit.messageHandlers.heartbeat.postMessage.bind(window.webkit.messageHandlers.heartbeat);
  let attempts = 0;
  while (attempts < 3) {
    try {
      const heartBeatPromise = new Promise((resolve, reject) => {
        window.webkit.messageHandlers.heartbeat
          .postMessage({}) // oxlint-disable-line require-post-message-target-origin -- webkit messageHandler
          .then((res: string) => {
            resolve(res);
            return undefined;
          })
          .catch((error: Error) => {
            reject(error);
          });
      });

      // oxlint-disable-next-line no-await-in-loop -- intentional sequential retry
      const result = await timeout(heartBeatPromise, 50, timeoutError);
      if (result === 'alive') {
        return result as string;
      }
      return 'dead';
    } catch (error) {
      if (error === timeoutError) {
        attempts = attempts + 1;
        continue;
      } else {
        throw error;
      }
    }
  }
  captureMessage(
    `Heartbeat failed three times in a row for payment ${paymentReference} on location ${locationId}- will return with no heartbeat`
  );
  return 'dead';
};
